import Model from '../model';
import * as actions from './actions'

class Tutorial extends Model {

    read() {
        return (dispatch) => {

            dispatch(actions.tutorialReadSuccess(true));

            /*
            return request
                .post(`${url}/v1/company/quick_response/get`)
                .send({})
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200)
                    {
                        const quickResponses = res.body.quick_responses;

                        quickResponses.sort(function(a, b) {
                            return (a.id - b.id);
                        });

                        dispatch(actions.quickResponseReadSuccess(quickResponses))
                    }
                    else
                    {
                        dispatch(actions.quickResponseReadFailure(err, res))
                    }
                });
            */
        }
    }

    setCurrentItem(id){
        return (dispatch) => {
            dispatch(actions.tutorialSetCurrentItem(id));
        }
    }

    setCurrentList(id){
        return (dispatch) => {
            dispatch(actions.tutorialSetCurrentList(id));
        }
    }

    setToDone(listId, itemId){
        return (dispatch) => {
            dispatch(actions.tutorialSetToDone(listId, itemId));
        }
    }
}


export default new Tutorial();



// WEBPACK FOOTER //
// ./src/model/Tutorial/model.js